module.exports = __webpack_public_path__ + "static/media/GCIPostAlertingAttentionSignal.0b3cf264.mp3";